<template>
  <div class="dict">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"><span></span>报损报溢单</div>
        </template>
        <div class="collapse-content">
          <!-- 表单区域 -->
          <SiruiSearch
            ref="formItem"
            :query="params"
            :columns="baseColumns"
            :isQueryPanel="false"
          ></SiruiSearch>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ this.$t('lossOverflowReport.form.baseTitle') }}</div
          >
        </template>
        <div class="collapse-content">
          <!-- 表单区域 -->
          <SiruiSearch
            ref="product1"
            :query="params"
            :columns="columns"
            :rules="rules"
            :isDisabledForm="isEdit"
            :isQueryPanel="false"
            @changeCurrency="changeCurrency"
          ></SiruiSearch>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <el-tabs type="border-card" v-model="activeNameTab" class="addCooperationTabs">
          <el-tab-pane name="first" label="损溢商品信息">
            <reportProduct
              ref="product"
              :defaultData="productData"
              :storageNo="params.storageNo"
              :departmentCode="params.decreaseOverflowDepartment"
              :decreaseOverflowType="params.decreaseOverflowType"
              :isEdit="isEdit"
            />
          </el-tab-pane>
          <el-tab-pane name="voucherTab" label="会计凭证">
            <voucher
              ref="voucher"
              :voucherList="voucherList"
              @reverseInfo="reverseInfo"
              @postInfo="postInfo"
              @doConfirmInfo="doConfirmInfo"
            ></voucher>
          </el-tab-pane>
        </el-tabs>
      </el-collapse-item>
      <el-collapse v-model="activeNames">
        <el-collapse-item name="4">
          <template slot="title">
            <div class="collapse-title-pre"
              ><span></span>{{ this.$t('applicationCredit.form.attachmentList') }}</div
            >
          </template>
          <div class="collapse-content">
            <upload
              ref="upload"
              @upload="uploadList"
              v-bind:tableData="attachmentList"
              v-bind:isShow="!isEdit"
            />
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        type="primary"
        v-if="!isEdit"
        :loading="load"
        @click="saveData('0')"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.save') }}</el-button
      >
      <el-button
        v-if="!isEdit"
        type="primary"
        :loading="load"
        @click="saveData('1')"
        class="fixed-bottom-btn"
        >{{ $t('dialog.submit') }}</el-button
      >
      <el-button
        v-if="
          (params.decreaseOverflowStatus == 0 || params.decreaseOverflowStatus == 2) &&
          isEdit == true
        "
        type="primary"
        :loading="load"
        @click="gotoEdit"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.edit') }}</el-button
      >
      <el-button
        v-if="
          (params.decreaseOverflowStatus == 0 || params.decreaseOverflowStatus == 2) &&
          isEdit == true
        "
        type="primary"
        :loading="load"
        @click="del"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.delete') }}</el-button
      >
      <!-- 确认 -->
      <el-button
        type="primary"
        v-if="params.decreaseOverflowStatus == 4"
        @click="doConfirm"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.confirm') }}</el-button
      >
      <!-- 生成凭证 -->
      <el-button
        v-if="
          params.decreaseOverflowStatus == 3 &&
          ['notgenerate', 'generated', 'postError'].indexOf(params.accountingStatus) != -1
        "
        type="primary"
        :loading="load"
        @click="handleAccountEntry"
        class="fixed-bottom-btn"
        >{{ $t('addInvoice.btns.accountEntry') }}</el-button
      >
      <!-- 过账凭证 -->
      <el-button
        v-if="
          params.decreaseOverflowStatus == 3 &&
          ['generated', 'postError'].indexOf(params.accountingStatus) != -1
        "
        type="primary"
        :loading="load"
        @click="doSyncVoucherForEntityData()"
        class="fixed-bottom-btn"
        >{{ $t('functionBtn.doSyncVoucher') }}</el-button
      >
      <el-button
        v-if="params.decreaseOverflowStatus == 3"
        type="primary"
        @click="doReverseAccountEntry()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.writeOff') }}
      </el-button>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import reportProduct from './components/reportProduct';
  import rules from './rules/rules';
  import BASE_API from '@/api/dataBase.js';
  import upload from '@/components/upload';
  import API from '@/api/wareHouse/lossOverflowReport.js';
  import voucherMixins from '@/common/mixins/voucher.js';
  export default {
    mixins: [voucherMixins],
    components: {
      reportProduct,
      upload,
    },
    name: 'lossOverflowReportBaseEdit',
    data() {
      return {
        load: false,
        activeNames: ['1', '2', '3', '4'], //默认展开那些面板，
        rules: rules.formRules,
        productRules: rules.productRules,
        productData: [],
        attachmentList: [],
        statusData: ['已保存', '审批中', '已驳回', '已执行', '已审核通过', '已冲销'],
        params: {
          decreaseOverflowNo: null,
          decreaseOverflowCreateDate: null,
          decreaseOverflowCompanyName: null,
          decreaseOverflowCreatePerson: null,
          decreaseOverflowStatusName: null,
          voucherNo: null,
          decreaseOverflowType: null,
          storage: null,
          storageName: null,
          storageNo: null,
          decreaseOverflowDepartment: null,
          decreaseOverflowBusinessPerson: null,
          decreaseOverflowBusinessPersonName: null,
          decreaseOverflowBusinessPersonNo: null,
          decreaseOverflowReason: 'SYYY07',
          decreaseOverflowPart: 'SYHJ05',
          decreaseOverflowMark: null,
        },

        voucherFlag: 'AE_INV_STOCK_TAKING', //凭证标识
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      isEdit() {
        return this.$route.query.isEdit ? JSON.parse(this.$route.query.isEdit) : false;
      },

      baseColumns() {
        return [
          {
            prop: 'decreaseOverflowNo',
            name: '报损报溢单号',
            type: 'input',
            disabled: true,
            placeholder: this.$t('lossOverflowReport.search.decreaseOverflowNoAdd'),
          },
          {
            prop: 'decreaseOverflowCreateDate',
            name: '制单日期',
            type: 'date',
            disabled: true,
          },
          {
            prop: 'decreaseOverflowCompanyName',
            name: this.$t('lossOverflowReport.search.decreaseOverflowCompanyName'),
            type: 'input',
            disabled: true,
          },
          {
            prop: 'decreaseOverflowCreatePersonName',
            name: this.$t('lossOverflowReport.search.decreaseOverflowCreatePerson'),
            type: 'input',
            disabled: true,
          },
          {
            prop: 'decreaseOverflowStatusName',
            name: this.$t('lossOverflowReport.search.decreaseOverflowStatus'),
            type: 'input',
            disabled: true,
          },
          {
            prop: 'voucherNo',
            name: this.$t('lossOverflowReport.search.voucherNo'),
            type: 'input',
            disabled: true,
            placeholder: this.$t('lossOverflowReport.search.voucherNoPlaceholder'),
          },
        ];
      },
      columns() {
        return [
          {
            prop: 'decreaseOverflowType', //报损报溢类型
            name: this.$t('lossOverflowReport.search.decreaseOverflowType'),
            type: 'select',
            placeholder: this.$t('lossOverflowReport.search.decreaseOverflowTypePlaceholder'),
            clearable: true,
            options: [
              { label: '报损', value: '0' },
              { label: '报溢', value: '1' },
            ],
          },
          {
            prop: 'storageNo', //仓库
            name: this.$t('lossOverflowReport.search.storageNo'),
            type: 'searchTableSpec',
            searchType: 'warehouse',
            extraData: {
              currentStatus: 'ZT03',
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            currentValue: this.params.storageName ? this.params.storageName : null,
            checkRowKeys: [this.params.storageNo ? this.params.storageNo : null],
            isMultiple: true,
            changeMethod: 'changeCurrency',
          },
          {
            prop: 'decreaseOverflowDepartmentName', //部门
            name: this.$t('lossOverflowReport.search.decreaseOverflowDepartmentNo'),
            type: 'input',
            disabled: true,
          },
          {
            prop: 'decreaseOverflowBusinessPerson', //业务员
            name: this.$t('lossOverflowReport.search.decreaseOverflowBusinessPerson'),
            type: 'searchTableSpec',
            searchType: 'personnel',
            extraData: {
              partnerTypes: 'HZHB03,HZHB02',
              requestStatus: 'ZT03',
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            currentValue: this.params.decreaseOverflowBusinessPersonName
              ? this.params.decreaseOverflowBusinessPersonName
              : null,
            checkRowKeys: [
              this.params.decreaseOverflowBusinessPersonNo
                ? this.params.decreaseOverflowBusinessPersonNamo
                : null,
            ],
            isMultiple: true,
            changeMethod: 'changeCurrency',
          },
          {
            prop: 'decreaseOverflowReason',
            name: this.$t('lossOverflowReport.search.decreaseOverflowReason'),
            type: 'ajaxSelect',
            clearable: false,
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'profitandloss_reason' },
            placeholder: this.$t('lossOverflowReport.search.decreaseOverflowReasonPlaceholder'),
          },
          {
            prop: 'decreaseOverflowPart',
            name: this.$t('lossOverflowReport.search.decreaseOverflowPart'),
            type: 'ajaxSelect',
            clearable: false,
            apiUrl: BASE_API.DIC_CREDIT_API,
            apiData: { dictType: 'profit_loss_part' },
            placeholder: this.$t('lossOverflowReport.search.decreaseOverflowReasonPlaceholder'),
          },
          {
            prop: 'decreaseOverflowMark',
            name: this.$t('lossOverflowReport.search.decreaseOverflowMark'),
            type: 'textarea',
            span: 24,
            placeholder: this.$t('lossOverflowReport.search.decreaseOverflowMarkPlaceholder'),
          },
        ];
      },
    },
    created() {
      if (this.$route.query.decreaseOverflowNo) {
        //修改和详情会传报损报溢单号
        //获取详情
        this.getDetail();
      } else {
        let userInfo = this.userInfo.userInfo;
        this.params.decreaseOverflowCompanyNo = userInfo.companyCode; //公司代码
        this.params.decreaseOverflowCompanyName = userInfo.companyName; //公司名称
        this.params.decreaseOverflowCreatePersonNo = userInfo.userCode; //制单人名称
        this.params.decreaseOverflowCreatePersonName = userInfo.userName; //制单人编码
        this.params.decreaseOverflowStatusName = '';
        this.params.decreaseOverflowDepartment = userInfo.departmentCode; //部门编码
        this.params.decreaseOverflowDepartmentNo = userInfo.departmentCode; //部门编码
        this.params.decreaseOverflowDepartmentName = userInfo.departmentName; //部门名称
        let newDate = new Date();
        this.params.decreaseOverflowCreateDate = newDate;
      }
    },
    methods: {
      // 确认
      doConfirmInfo(info) {
        this.startLoading();
        let params = {
          id: this.params.id,
          decreaseOverflowNo: this.params.decreaseOverflowNo,
          ...info,
        };
        this.$axios
          .post(API.DO_CONFIRM, params)
          .then((res) => {
            this.endLoading();
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: this.$t('message.success'),
                type: 'success',
              });
              this.getDetail();
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          })
          .catch(() => this.endLoading());
      },
      //获取详情
      getDetail() {
        this.$axios.get(API.DETAIL_API + this.$route.query.decreaseOverflowNo).then((res) => {
          if (res.data.code === 0) {
            this.params = res.data.data;
            this.productData = this.params.detailList;
            console.log(this.productData);
            if (this.productData && this.productData.length > 0) {
              this.productData.map(async (item) => {
                if (item.decreaseOverflowPackage == null) {
                  item.decreaseOverflowPackage = '';
                }
                item.newDecreaseOverflowPercent =
                  Number(item.decreaseOverflowPercent, 100).toFixed(6) + '%';
                let params = {
                  batchNo: item.batchNo,
                };
                await this.$axios.post(API.LIST_INBOUND, params).then((res) => {
                  if (res.data.code === 0) {
                    item.leftInboundQuantity = res.data.data[0].storageQuantity;
                    return item;
                  }
                });
              });
            }
            this.attachmentList = this.params.distributionAttachmentDos;
            this.params.decreaseOverflowStatusName =
              this.statusData[this.params.decreaseOverflowStatus];
            // 仓库
            // this.params.storage={
            //   storageName: this.params.storageName||null,
            //   storageNo: this.params.storageNo||null,
            // }
            //部门
            this.params.decreaseOverflowDepartment =
              this.params.decreaseOverflowDepartmentNo || null;
            this.$nextTick(() => {
              this.$refs.formItem.clearValidate();
            });

            // 获取凭证ID 获取凭证列表
            this.entityDataId = this.params.id;
            this.getAccountEntry();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //修改表单信息
      changeCurrency(obj) {
        //仓库
        if (obj.prop == 'storageNo') {
          if (obj.val && obj.val[0].storageCode != this.params.storageNo) {
            this.params.storageName = obj.val ? obj.val[0].storageName : null;
            this.params.storageNo = obj.val ? obj.val[0].storageCode : null;
            this.productData = [];
          } else {
            this.params.storageName = null;
            this.params.storageNo = null;
            this.params.storage = null;
            this.productData = [];
          }
        } else if (obj.prop == 'decreaseOverflowBusinessPerson') {
          this.params.decreaseOverflowBusinessPersonNo = obj.val ? obj.val[0].id + '' : null;
          this.params.decreaseOverflowBusinessPersonName = obj.val ? obj.val[0].personName : null;
        } else if (obj.prop == 'decreaseOverflowDepartment') {
          this.params.decreaseOverflowDepartmentPersonName = obj.val ? obj.val.label : null;
          this.params.decreaseOverflowDepartmentPersonNo = obj.val ? obj.val.id : null;
          this.params.decreaseOverflowDepartment = obj.val ? obj.val.id : null;
          this.productData = [];
        }
      },
      //更新附件列表
      uploadList(value) {
        this.attachmentList = value;
      },
      //保存/提交
      async saveData(type) {
        const that = this;
        //基本信息-验证
        const baseData = await this.$refs.formItem.getValidateFormData();
        //产品明细-验证
        const product = await this.$refs.product1.getValidateFormData();
        //获取产品明细
        const goodsList = this.$refs.product.getValues();
        // ===========sunxueping TAPD[ID1000844]需求增加批次号查重校验逻辑===========
        let batchNoList = goodsList.map((item) => {
          return item.batchNo;
        });
        if (batchNoList.length > Array.from(new Set(batchNoList)).length) {
          return this.$message({
            showClose: true,
            message: '不同行项目不可重复同一批次号（相同批次号只能在一行）',
            type: 'error',
          });
        }
        // =========================================================================
        //如果是提交  需要校验商品行项目
        if (goodsList.length == 0 && type == '1') {
          this.$message({
            showClose: true,
            message: this.$t('xTable.saveNoData'),
            type: 'error',
          });
          return;
        }
        Promise.all([baseData, product]).then(() => {
          this.loading.startLoading();
          // 获取基础信息值
          // const baseData = XEUtils.clone(this.$refs.formItem.getValues(), true);
          baseData.decreaseOverflowStatus = '0';
          baseData.detailList = goodsList;
          baseData.distributionAttachmentDos = this.attachmentList;
          let url = type === '0' ? API.SAVE_API : API.SUBMIT_API;
          that.$axios.post(url, baseData).then((res) => {
            this.loading.endLoading();
            if (0 != res.data.code) {
              if (type === '1') {
                if (res.data.data) {
                  if (that.$route.name == 'lossOverflowReportAdd') {
                    that.dblclickEvent(res.data.data);
                  } else {
                    that.getDetail();
                  }
                }
              }
              that.$alert(res.data.msg);
            } else {
              if (type == '0') {
                if (that.$route.name == 'lossOverflowReportAdd') {
                  that.dblclickEvent(res.data.data);
                } else {
                  that.getDetail();
                }
              } else {
                that.gotoList(false);
              }
              that.$message({
                showClose: true,
                message: res.data.msg || that.$t('message.success'),
                type: 'success',
              });
            }
          });
        });
      },
      //保存--修改
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/wareHouse/lossOverflowReportAdd',
            name: 'lossOverflowReportAdd',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/wareHouse/lossOverflowReportDetail',
            name: 'lossOverflowReportDetail',
            meta: {
              keepAlive: false,
            },
            query: { decreaseOverflowNo: value.decreaseOverflowNo, isEdit: true },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //删除
      del() {
        const that = this;
        this.$confirmAction()
          .then(() => {
            this.loading.startLoading();
            that.$axios.get(API.DEL_API + this.$route.query.decreaseOverflowNo).then((res) => {
              this.loading.endLoading();
              if (0 != res.data.code) {
                that.$alert(res.data.msg);
              } else {
                that.gotoList(false);
                that.$message({
                  showClose: true,
                  message: res.data.msg || that.$t('message.success'),
                  type: 'success',
                });
              }
            });
          })
          .catch(() => {
            this.loading.endLoading();
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //跳转到列表页面
      gotoList(flag) {
        let oldPath = 'lossOverflowReportAdd';
        if (this.$route.query.decreaseOverflowNo && this.isEdit) {
          oldPath = 'lossOverflowReportEdit';
        } else if (this.$route.query.decreaseOverflowNo && !this.isEdit) {
          oldPath = 'lossOverflowReportDetail';
        }
        let path = {
          fromPath: {
            path: '/wareHouse/' + oldPath,
            name: oldPath,
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/wareHouse/lossOverflowReportList',
            name: 'lossOverflowReportList',
            meta: {
              keepAlive: flag,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //跳转到编辑页面
      gotoEdit() {
        let path = {
          fromPath: {
            path: '/wareHouse/lossOverflowReportDetail',
            name: 'lossOverflowReportDetail',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/wareHouse/lossOverflowReportEdit',
            name: 'lossOverflowReportEdit',
            meta: {
              keepAlive: false,
            },
            query: { decreaseOverflowNo: this.$route.query.decreaseOverflowNo, isEdit: false },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .collapse-main-content {
    margin-bottom: 10px;
  }
</style>
<style>
  .el-collapse-item__wrap {
    overflow: inherit !important;
  }
</style>
